import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TicketService } from '../../services';
import { Utils } from '../../utils';
import { ValidationInputData } from '../../models';

@Component({
    selector: 'app-validation',
    templateUrl: './validation.component.html',
    styleUrls: ['./validation.component.css']
})

export class ValidationComponent implements OnInit {

    loading: boolean;
    partTicketNumber: string;
    ticketNumber: string;
    errorMsg: string;
    infoMsg: string;
    tickets: Array<string> = [];
    result: number;
    configs: Array<any> = [];
    addedInfo: Map<number, string> = new Map<number, string>();

    constructor(
        public router: Router,
        public utils: Utils,
        private ticketService: TicketService) { }

    ngOnInit() {
        this.ticketService.getValidationConfigs()
            .subscribe(
                configs => {
                    this.configs = configs;
                    console.log(configs);
                    this.configs.forEach(value => {
                        if (value.validationProvider.featureParametersMap != null && value.validationProvider.featureParametersMap[2] != null) {
                            this.addedInfo.set(value.id, '');
                        }
                    });
                }, error => {
                    console.log(error);
                });
    }

    searchTicket(): void {
        this.infoMsg = '';
        if (this.loading) { return; }
        this.errorMsg = '';
        this.tickets = [];

        if (this.partTicketNumber.length <= 5) { return; }

        this.loading = true;
        this.result = null;
        this.ticketService.findByPartTicketNumber(this.partTicketNumber)
            .subscribe(
                tickets => {
                    this.tickets = tickets || [];
                    this.loading = false;
                    if (this.tickets.length == 1) {
                        this.selectTicket(this.tickets[0]);
                    }
                    else if (this.tickets.length == 0) {
                        this.errorMsg = 'Nie ma takiego biletu.';
                    }
                }, error => {
                    console.log("searchTicket error", error);
                    this.errorMsg = this.utils.handleError(error);
                    this.loading = false;
                });
    }

    selectTicket(ticket: string): void {
        this.errorMsg = null;
        this.infoMsg = null;
        this.ticketNumber = ticket;
        this.ticketService.chargeValue(ticket)
            .subscribe(
                result => {
                    this.result = result.turnover;
                    console.log(result);
                },
                error => {
                    console.log("selectTicket error", error);
                    this.errorMsg = this.utils.handleError(error);
                }
            );
    }

    validate(conf: any) {
      this.loading = true;
      this.errorMsg = null;
      console.log(conf);
      if (conf.validationProvider.featureParametersMap && conf.validationProvider.featureParametersMap[3] && conf.validationProvider.featureParametersMap[3].value == 'true') {
          if (this.addedInfo[conf.id] == null || this.addedInfo[conf.id] == '') {
              this.errorMsg = "Pole '" + conf.validationProvider.featureParametersMap[2].value + "' jest wymagane";
              return;
          }
      }
      let validationData = new ValidationInputData();
      validationData.validationConfigurationId = conf.id;
      validationData.ticketNumber = this.ticketNumber;
      validationData.validationAddInfo = this.addedInfo[conf.id];
      this.ticketService.validateTicket(validationData)
          .subscribe(
              () => {
                  console.log('Bilet został zwalidowany');
                  this.ticketNumber = null;
                  this.partTicketNumber = null;
                  this.tickets = [];
                  this.addedInfo[conf.id] = '';
                  this.result = null;
                  this.infoMsg = "Bilet został zwalidowany";
              },
              (error) => {
                  console.log('error', error);
                  this.errorMsg = 'Bilet nie został zwalidowany. ' + this.utils.handleError(error);
              },
              () => {
                  console.log('complete');
                  this.loading = false;
                  this.infoMsg = "Bilet został zwalidowany";
              });
    }
}
